const get = require('lodash/get');
const memoize = require('memoizee');

const logger = require('@dbk-legacy/fell').getLogger('roster.Config');

function loadConfig(id) {
  const dir = process.env.NODEJSAPP_CONFIG_DIR;
  let json;

  if (!dir) {
    return json;
  }

  const filePath = `${dir}/${id}.json`;

  try {
    // eslint-disable-next-line global-require
    json = require(filePath);
    // logger.info(`Loaded '${id}' config from '${filePath}'`);
  } catch (e) {
    logger.error(`Unable to load config from '${filePath}' with error: ${e.message}`);
  }

  return json;
}

const memoizedLoadConfig = memoize(loadConfig);

function getConfig(id, getPath, defaultConfig = {}) {
  const json = memoizedLoadConfig(id);
  let config = json;
  let pathMessage = '';

  if (getPath) {
    if (config) {
      config = get(config, getPath);
    }
    pathMessage = ` for path '${getPath}'`;
  }

  if (!config) {
    config = defaultConfig;
    const stringifiedConfig = JSON.stringify(config, null, 2);
    logger.warn(
      `'${id}' config not found${pathMessage}. Using default:\n${stringifiedConfig}`
    );
  }

  return config;
}

function getConfigClient(id, getPath, defaultConfig = {}) {
  return defaultConfig;
}

function isClient() {
  return typeof window !== 'undefined';
}

module.exports = isClient() ? getConfigClient : getConfig;
